<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Pembelian</h2>
      <v-spacer></v-spacer>
      <div class="listtotal">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Total Trx</div>
            <div>{{formatAngka(sumbuy[0])}}</div>
          </div>
        </v-card>
        <v-card class="listtotal" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Amount Trx</div>
            <div>{{formatAngka(sumbuy[1])}}</div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2" style="border: thin solid rgba(0,0,0,.12)">
      <v-tabs  v-model="tab">
        <v-tab>Pembelian</v-tab>
        <v-tab>Produk ke Suplier</v-tab>
        <v-tab-item>
          <TrxPembelian/>
        </v-tab-item>
        <v-tab-item>
          <ProdukMapping/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import TrxPembelian from '@/components/TrxPembelian'
import ProdukMapping from '@/components/ProdukMapping'
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
export default {
  name: 'Pembelian',
  components: { ProdukMapping, TrxPembelian },
  data: () => ({
    tab: null
  }),
  mounted () {
    this.getSumBuy()
    this.getCategory()
    this.getBrands()
  },
  computed: {
    ...mapState('TrxPembelian', ['sumbuy'])
  },
  methods: {
    ...mapActions('ProductStore', ['getCategory', 'getBrands']),
    ...mapActions('TrxPembelian', ['getSumBuy']),
    formatAngka (val) {
      return Utils.formatAngka(val)
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 5px;
}
</style>
